(function (app) {
    app.provider("productApi", [function () {
        this.$get = ["complianceHubApiGateway", "$q", function (complianceHubApiGateway, $q) {
            var service = {};

            service.getProducts = function () {
                return complianceHubApiGateway.getArray("/Products");
            };
          
            service.getProduct = function(productId) {
                return complianceHubApiGateway.get("/Products/" + productId);
            };

            service.getArcProduct = function(arcProductId) {
                return complianceHubApiGateway.get("/Products/Arc/" + arcProductId);
            };

            service.updateProduct = function(product) {
                return complianceHubApiGateway.put("/Products/" + product.Id, product);
            };

            service.updateAllProducts = function () {
                return complianceHubApiGateway.put("/Products/UpdateProducts/");
            };

            service.getTransactionGroupsForProduct = function(productId) {
                return complianceHubApiGateway.getArray("/Products/" + productId + "/TransactionGroups");
            };

            service.getActiveProducts = function () {
                return complianceHubApiGateway.getArray("/Products/Active/");
            };

            return service;
        }];
    }]);
})(window.app); // jshint ignore:line